export default __webpack_public_path__ + "static/media/stolen-red.33981985.svg";